import { internalComputeVolumeLabelmapFromStack } from '../SegmentationStateManager';
export async function computeVolumeLabelmapFromStack(args) {
    return internalComputeVolumeLabelmapFromStack(args);
}
